import { gql } from '@apollo/client';
import BASE_USER_SETTING_FRAGMENT from 'graph/fragments/user-setting';

const SAVE_USER_SETTING_MUTATION = gql`
  mutation UpdatePliUserSetting($data: PliUserSettingInput!) {
    updatePliUserSetting(data: $data) {
      ...BaseUserSetting
    }
  }
  ${BASE_USER_SETTING_FRAGMENT}
`;

export default SAVE_USER_SETTING_MUTATION;
